import { SitPosition } from 'game-play-services'

interface ViewGamePlayerProps {
  readonly username: string
  readonly sitPosition: SitPosition
  readonly isSitting: boolean
  readonly isCreator: boolean
  readonly isInvited: boolean
}

export class ViewGamePlayer {
  public readonly username = this.viewGamePlayerProps.username
  public readonly sitPosition = this.viewGamePlayerProps.sitPosition
  public readonly isSitting = this.viewGamePlayerProps.isSitting
  public readonly isCreator = this.viewGamePlayerProps.isCreator
  public readonly isInvited = this.viewGamePlayerProps.isInvited
  public readonly isLeftPlayer = this.sitPosition === 'Left'
  public readonly isRightPlayer = this.sitPosition === 'Right'

  public constructor(private viewGamePlayerProps: ViewGamePlayerProps) {}
}

export const viewGamePlayerNull: ViewGamePlayer = new ViewGamePlayer({
  username: '',
  sitPosition: 'Left',
  isSitting: false,
  isCreator: false,
  isInvited: false,
})
